<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
// import echarts from 'echarts'
import * as echarts from 'echarts';
require('echarts/theme/macarons') // echarts theme
import resize from './mixins/resize'
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Number,
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    unit: {
      type: String,
      default: ''
    },
    min: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: null
    },
    color: {
      type: String,
      default: '#FFAB91'
    },
    size: {
      type: Number,
      default: 16
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val, this.unit, this.min, this.max, this.color, this.size)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData, this.unit, this.min, this.max, this.color, this.size)
    },
    setOptions(data = null, unit = '', min = null, max = null, color, size = 16) {
      let _this = this
      this.chart.setOption({
        // color: ['#80FFA5', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00'],
        // backgroundColor: 'transparent',
        title: {
          text: this.title,
          left: 'center',
          bottom: 0,
          textStyle: {
            color: '#6ab8ff',
            fontWeight: 'bold',
            fontSize: 14,
            lineHeight: 24
          },
          padding: 0
        },
        // grid: {
        //   left: 10,
        //   right: 10,
        //   bottom: 40,
        //   top: 25,
        //   containLabel: true
        // },
        // series: yData,
        // responsive: true,
        // aspectScale: 1, // 这个值可以根据你的需求调整
        series: [
          {
            type: 'gauge',
            center: ['50%', '50%'],
            startAngle: 200,
            endAngle: -20,
            min,
            max,
            radius: '100%',
            splitNumber: 12,
            itemStyle: {
              color
            },
            progress: {
              show: true,
              roundCap: data,
              width: 6
            },
            pointer: {
              show: false
            },
            axisLine: {
              roundCap: true,
              lineStyle: {
                width: 6,
                color: [
                  [1, '#30469a']
                ]
              }
            },
            axisTick: {
              show: false,
              distance: -3,
              splitNumber: 5,
              lineStyle: {
                width: 1,
                color: '#999'
              }
            },
            splitLine: {
              show: false,
              distance: -3,
              length: 10,
              lineStyle: {
                width: 3,
                color: '#999'
              }
            },
            axisLabel: {
              show: false,
              distance: -5,
              color: '#999',
              fontSize: 10
            },
            anchor: {
              show: false
            },
            title: {
              show: false
            },
            detail: {
              valueAnimation: true,
              width: '60%',
              lineHeight: 40,
              borderRadius: 8,
              offsetCenter: [0, '-10%'],
              fontSize: size,
              fontWeight: 'bolder',
              // formatter: unit ? `{value} ${unit}` : `{value}`,
              formatter: (value) => {
                if(isNaN(value)) {
                  return '-'
                } else {
                  let val = Math.round(value)
                  return unit ? `${val}${unit}` : `${val}`
                }
              },
              color: 'inherit'
            },
            data: [
              {
                value: data
              }
            ]
          },
          // {
          //   type: 'gauge',
          //   center: ['50%', '60%'],
          //   startAngle: 200,
          //   endAngle: -20,
          //   min: 0,
          //   max: 60,
          //   itemStyle: {
          //     color: '#FD7347'
          //   },
          //   progress: {
          //     show: true,
          //     width: 8
          //   },
          //   pointer: {
          //     show: false
          //   },
          //   axisLine: {
          //     show: false
          //   },
          //   axisTick: {
          //     show: false
          //   },
          //   splitLine: {
          //     show: false
          //   },
          //   axisLabel: {
          //     show: false
          //   },
          //   detail: {
          //     show: false
          //   },
          //   data: [
          //     {
          //       value: 20
          //     }
          //   ]
          // }
        ]
      })
    }
  }
}
</script>